import {emotionStyled} from '@packages/utilities/styled';

export const SVGWrapper = emotionStyled('svg')(
  {
    pointerEvents: 'none',
  },
  {
    componentName: 'MaskSVGWrapper',
    variants: {
      fill: {
        transparent: {
          fill: 'transparent',
        },
        popover: {
          fill: '$uiPopoverBackdrop',
        },
        default: {
          fill: '$uiModalBackdrop',
        },
      },
    },
  }
);
